import React from 'react';
import Link from 'next/link';
import SupportIconStyles from './SupportIconStyles';

const SupportIcon = ({ data }) => {

  return (
    <SupportIconStyles className="support-icon">
      <Link href={data.learn_more_url}>
        <div className="icon-container">
          <img className="icon-image" src={data.icon.url} />
          <div className="icon-title-container">
            <div className="icon-title">{data.title}</div>
            {data.description !== 'null' && data.description &&
              <div className="icon-description">{data.description}</div>
            }
          </div>
        </div>
      </Link>
    </SupportIconStyles>
  );
};

export default SupportIcon;